const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || "https://sodit.cyou:7443";

export function getEdcUrlSingle(apiName, countryCode, id) {
    return `${API_BASE_URL}/${apiName}/${countryCode}/${id}`;
}

export function getCreateNewsUpdate() {
    return `${API_BASE_URL}/newsupdate-api/`;
}

export function getCopyNewsUpdateUrl() {
    return `${API_BASE_URL}/newsupdate-api/copy`;
}

export function getEdcUrl(apiName, countryCode, languageCode, areaId, offset, maxNumberOfRows, keyword, selected) {
    let url;

    if (apiName === "immi-api" || apiName === "home-api") {
        if (selected === undefined)
            selected = true

        url = `${API_BASE_URL}/${apiName}/${countryCode}/${offset}/${maxNumberOfRows}/${selected}`
        if (keyword !== undefined)
            url = `${API_BASE_URL}/${apiName}/${countryCode}/${keyword}/${offset}/${maxNumberOfRows}/${selected}`

    } else {
        url = `${API_BASE_URL}/${apiName}/${countryCode}/${languageCode}/${areaId}/${offset}/${maxNumberOfRows}`
        if (keyword !== undefined)
            url = `${API_BASE_URL}/${apiName}/${countryCode}/${languageCode}/${keyword}/${areaId}/${offset}/${maxNumberOfRows}`
    }
    return url;
}

export function getNewsUpdateUrl(areaId, viewed, page = 1, limit = 10) {
    let url = `${API_BASE_URL}/newsupdate-api/${areaId}?page=${page}&limit=${limit}`;
    if (viewed !== undefined) {
        url += `&viewed=${viewed}`;
    }
    return url;
}

export function getToogleViewedNewsUpdateUrl(id) {
    return `${API_BASE_URL}/newsupdate-api/${id}/viewed`;
}

export function getDeleteNewsUpdateUrl(id) {
    return `${API_BASE_URL}/newsupdate-api/${id}`;
}

export function getUpdateNewsContentUrl(id) {
    return `${API_BASE_URL}/newsupdate-api/${id}`;
}

export const getUpdateNewsLocationUrl = (newsId, areaId) => {
    return `${API_BASE_URL}/newsupdate-api/${newsId}/location?areaId=${areaId}`;
};
